export const sendToWhatsapp = data => {
	const wa = `https://api.whatsapp.com/send?phone=&text=${encodeURIComponent(data)}`;
	window.location.href = wa;
};

export default {
	sendToWhatsapp,
};
